import { render, staticRenderFns } from "./ServiceProjectInfo.vue?vue&type=template&id=a8c45050&scoped=true&"
import script from "./ServiceProjectInfo.vue?vue&type=script&lang=js&"
export * from "./ServiceProjectInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c45050",
  null
  
)

export default component.exports